<template>
  <div style="margin-bottom:50px;">
    <Title
      :pages="[{ icon: 'box', page: page_title.toUpperCase() }]"
    ></Title>

    <div
      style="padding:20px;margin-top:50px"
      v-if="list_access || create_access"
    >
      <v-tabs v-model="tab">
        <v-tab v-for="item in items" :key="item.key">
          {{ item.tab }}
        </v-tab>
      </v-tabs>

      <v-tabs-items v-model="tab">
        <v-tab-item
          @click="tab = 0"
          key="0"
          style="background:#f5f5f5"
          class="elevation-1"
        >
          <Producto></Producto>
        </v-tab-item>
        <v-tab-item
          @click="tab = 1"
          key="1"
          style="background:#f5f5f5"
          class="elevation-1"
        >
          <LineaProducto></LineaProducto>
        </v-tab-item>
        <v-tab-item
          @click="tab = 2"
          key="2"
          style="background:#f5f5f5"
          class="elevation-1"
        >
          <FamiliaProducto></FamiliaProducto>
        </v-tab-item>
      </v-tabs-items>
    </div>
  </div>
</template>

<script>
import Producto from "./Producto";
import LineaProducto from "../LineaProducto/LineaProducto";
import FamiliaProducto from "../FamiliaProducto/FamiliaProducto";
import Title from "@/components/Title.vue";
import RolMixin from "@/mixins/RolMixin.vue";
export default {
  components: {
    Title,
    Producto,
    LineaProducto,
    FamiliaProducto,
  },
  mixins: [RolMixin],
  data() {
    return {
      page_title: "Productos",
      tab: 0,
      items: [
        { tab: "Productos", key: "0" },
        { tab: "Líneas de Producto", key: "1" },
        { tab: "Familias de Producto", key: "2" },
      ],
    };
  },
  mounted() {},
  methods: {},
};
</script>
